"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AudienceListItem = void 0;
var _react = require("react");
var _hooks = require("../../../../../../../../../hooks");
var _List = require("../../../../../../../../../Data/List");
var _StudentsListItem = require("../StudentsListItem");
var _jsxRuntime = require("react/jsx-runtime");
const AudienceListItem = props => {
  const {
    isItemReadonly,
    isSelected,
    id,
    audienceType,
    fullName,
    onChange,
    onDisabledItemClick,
    mapper
  } = props;
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const [isItemHover, setIsItemHover] = (0, _react.useState)(false);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_List.List.Item, {
    id: id,
    isDisabled: isItemReadonly,
    isSelected: isSelected,
    onClick: onChange,
    onDisabledClick: onDisabledItemClick,
    onMouseEnter: () => {
      setIsItemHover(true);
    },
    onMouseLeave: () => {
      setIsItemHover(false);
    },
    isWithCheckbox: isMobileView,
    checkboxVerticalAlign: audienceType === 'students' ? 'middle' : 'top',
    color: "primary",
    children: audienceType === 'students' ? mapper && mapper[id] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_StudentsListItem.StudentsListItem, {
      ...props,
      fullName: fullName,
      id: id,
      isItemHoverOrSelected: isSelected || isItemHover
    }) : mapper && mapper[id] && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      children: mapper[id].group.name
    })
  }, id);
};
exports.AudienceListItem = AudienceListItem;